<template>
  <div class="search-layout" @click="showExist = false">
    <div class="blue-bg">
      <div class="search-box">
        <i class="iconfont iconfanhui back" @click.stop="goback"></i>
        <div class="search" @click.stop="$router.push('/search')">
          <div class="input-link">
            <i class="iconfont iconsousuo"></i>
            搜索
          </div>
        </div>
        <i class="iconfont iconcaidan menu" @click.stop="showExist = !showExist"></i>
      </div>

      <div class="search-message">
        <slot name="icon" v-if="source"><img class="sourceicon" src="../assets/images/source/zuyuan.png" alt="祖源"></slot>
        <slot name="title"><p class="title">{{ title }}</p></slot>
        <slot name="attent"><p class="attent">{{ attent }}</p></slot>
        <slot name="total"><p class="total">{{ total }}</p></slot>
        <slot name="conclusion" v-if="gdb3">
          <p class="conclusion" v-if="conclusion === 5">需要重点关注</p>
          <p class="conclusion" v-if="conclusion === 3">可以适当关注</p>
          <p class="conclusion" v-if="conclusion === 1">可以了解</p>
          <p class="conclusion" v-if="conclusion === 2">可适当了解</p>
          <p class="conclusion" v-if="conclusion === 4">需要关注</p>
        </slot>
        <slot name="conclusion" v-if="gdb2">
          <p class="conclusion" v-if="conclusion === '高风险'">需要重点关注</p>
          <p class="conclusion" v-if="conclusion === '一般风险'">可以适当关注</p>
          <p class="conclusion" v-if="conclusion === '低风险'">可以了解</p>
          <p class="conclusion" v-if="conclusion === '较低风险'">可适当了解</p>
          <p class="conclusion" v-if="conclusion === '较高风险'">需要关注</p>
        </slot>
      </div>
    </div>

    <div class="search-body">
      <slot></slot>
    </div>
    <SideBar :show="showExist" :child="child"></SideBar>
  </div>
</template>

<script>
import SideBar from '../components/SideBar.vue'
export default {
  props: ['backurl', 'title', 'attent', 'total', 'conclusion', 'child', 'source'],
  data: function () {
    return {
      gdb3: false,
      gdb2: false,
      showExist: false
    }
  },
  methods: {
    goback () {
      let backurl = this.backurl
      if (backurl) {
        this.$router.push(backurl)
      } else {
        this.$router.back()
      }
    }
  },
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
    } else {
      this.gdb2 = true
    }
  },
  components: {
    SideBar
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/functions";
  .search-layout {
    height: 100%;

    .blue-bg {
      width: 100%;
      background: #00a0e8 linear-gradient(160deg, #34C2E0 0, #44A2CF pxToRem(266px));
      height: pxToRem(266px);
      padding: 0 pxToRem(25px);

      .search-box {
        display: flex;
        min-height: pxToRem(120px);
        padding-top: pxToRem(15px);

        .search {
          z-index: 1;
          width: 100%;
          height: pxToRem(55px);
          line-height: pxToRem(55px);
          margin: 0 pxToRem(60px);

          .input-link {
            text-align: center;
            height: 100%;
            border-radius: 15px;
            color: #fff;
            border: pxToRem(1px) solid #fafdfe;
          }
        }
      }

      .search-message {
        color: #fff;

        .sourceicon {
          float: left;
          width: pxToRem(100px);
          height: pxToRem(100px);
          margin-right: pxToRem(30px);
        }

        .title {
          display: inline-block;
          font-size: pxToRem(35px);
          letter-spacing: 1px;
        }

        .attent {
          display: inline-block;
          float: right;
          font-size: pxToRem(25px);
        }

        .total {
          margin-top: pxToRem(15px);
          text-align: right;
          font-size: pxToRem(30px);
        }

        .conclusion {
          font-size: pxToRem(25px);
        }
      }
    }
  }
  .search-layout .menu, .search-layout .back {
    z-index: 999;
    padding-top: pxToRem(10px);
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Search.vue